import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '~components/ui/select';

/* -------------------------------------------------------------------------- */
/*                                    Types                                   */
/* -------------------------------------------------------------------------- */

type NeighbouringHoleColourByMode = 'blast' | 'rl' | 'diameter' | 'depth' | 'bearing' | 'dip' | 'drill_model';

type NeighbouringHoleColourBySelectProps = {
  /** Active neighbouring hole colour mode */
  value: NeighbouringHoleColourByMode;
  /** Called when the colour mode changes */
  onChange: (mode: NeighbouringHoleColourByMode) => void;
};

/* -------------------------------------------------------------------------- */
/*                               Main component                               */
/* -------------------------------------------------------------------------- */

/**
 * Selector for neighbouring drill hole colour mode.
 */
const NeighbouringHoleColourBySelect = ({ value, onChange }: NeighbouringHoleColourBySelectProps) => {
  return (
    <>
      <p className="font-bold text-base">Colour Holes By</p>
      <Select value={value} onValueChange={(nextValue) => onChange(nextValue as NeighbouringHoleColourByMode)}>
        <SelectTrigger className="w-full text-sm">
          <SelectValue placeholder="Select a parameter" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="blast">Blast</SelectItem>
          <SelectItem value="rl">Reduced Level (RL)</SelectItem>
          <SelectItem value="diameter">Diameter</SelectItem>
          <SelectItem value="depth">Depth</SelectItem>
          <SelectItem value="bearing">Bearing</SelectItem>
          <SelectItem value="dip">Dip</SelectItem>
          <SelectItem value="drill_model">Drill Model</SelectItem>
        </SelectContent>
      </Select>
    </>
  );
};

/* -------------------------------------------------------------------------- */
/*                                   Exports                                  */
/* -------------------------------------------------------------------------- */

export { type NeighbouringHoleColourByMode, NeighbouringHoleColourBySelect };
